export function normalizeUrl(url) {
  if (!url || url.includes('://')) {
    return url;
  }
  if (url.startsWith('//')) {
    return "http:".concat(url);
  }
  return "http://".concat(url);
}